"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {}
};

/**
 * Describe the purpose of ModalHeader here
 */
var ModalHeader = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ModalHeader, _React$Component);
  function ModalHeader() {
    (0, _classCallCheck2["default"])(this, ModalHeader);
    return _callSuper(this, ModalHeader, arguments);
  }
  (0, _createClass2["default"])(ModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        theme = _this$props.theme,
        testId = _this$props.testId,
        children = _this$props.children,
        onClose = _this$props.onClose,
        isDanger = _this$props.isDanger;
      var classes = (0, _classnames["default"])(className, theme.modalHeader, (0, _defineProperty2["default"])({}, theme.danger, isDanger));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        "data-test-id": testId,
        "data-anypoint-component": ModalHeader.displayName
      }, children, onClose && /*#__PURE__*/_react["default"].createElement("button", {
        "data-test-id": testId && "modal-close-".concat(testId),
        onClick: onClose
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: "close",
        className: theme.close,
        title: "Close"
      })));
    }
  }]);
  return ModalHeader;
}(_react["default"].Component);
(0, _defineProperty2["default"])(ModalHeader, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(ModalHeader, "displayName", 'ModalHeader');
//# sourceMappingURL=ModalHeader.js.map